//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Calendar from './Agenda/Calendar.vue';
import Date from './Agenda/Date.vue';
export default {
  name: 'Agenda',
  components: {
    Calendar,
    Date,
  },
  props: {
    expert: String,
    ajax: String,
  },
  data: function(){
    return {
      date: '',
    };
  },
  methods: {
    handleDateSelect: function(date){
      this.date = date;
    },
    handleSuccess: function(){
      this.$refs.calendar.reload()
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Agenda.vue